import axios from "axios"

const CALLBOX_URL = "https://scripts.callbox.co.il/mazda/forms2cb.php"

export const postCallboxLead = async (
  formType: "test-drive" | "contact",
  leadRequest: any
) => {
  try {
    await axios.post(CALLBOX_URL, {
      ...leadRequest,
      sid: window?.__ctm?.config?.sid || "",
      formType,
    })
  } catch (error) {
    console.log(error)
  }
}
